const headersLogsSip = [
  {
    text: 'id',
    value: 'doorphone_id',
  },
  {
    text: 'Адрес',
    value: 'address',
  },
  {
    text: 'Старый sip-статус',
    value: 'oldSipStatus',
  },
  {
    text: 'Новый sip-статус',
    value: 'newSipStatus',
  },
  {
    text: 'Дата и время',
    value: 'updated',
  },
];

const detailCheckCamerasJournal = [
  { text: 'id', value: 'doorphone_id', width: '1%', sortable: false },
  { text: 'Адрес', value: 'address', width: '35%' },
  { text: 'ip адрес', value: 'ip_address', width: '10%', sortable: false },
  { text: 'mac адрес', value: 'mac_address', width: '10%', sortable: false },
  { text: 'Настройки', value: 'cameraHasSettings', width: '1%', sortable: false },
  { text: 'Канал', value: 'cameraHasChannel', width: '1%', sortable: false },
  { text: 'Объект', value: 'cameraHasEntity', width: '1%', sortable: false },
  { text: 'Статус', value: 'status', width: '20%', sortable: false },
];

const headersLogs = [
  {
    text: 'кол-во sip статусов',
    value: 'logs_count',
  },
  {
    text: 'Статус',
    value: 'logsStatus',
  },
  {
    text: 'Дата и время',
    value: 'timeInterval',
  },
];

const SIP_STATUS = {
  0: 'Отключен',
  1: 'Регистрация',
  2: 'Зарегистрирован',
  3: 'Не удалось зарегистрироваться',
  null: 'Не в сети',
};

export { SIP_STATUS, headersLogsSip, headersLogs, detailCheckCamerasJournal };
